import Swiper from "swiper/bundle";

export function idxFunc() {
  //スライド
  const swiper = new Swiper('#top-slide', {
    loop: true,
    autoplay: {
      delay: 5000,
    },
    speed: 1000,
    // centeredSlides: true,
    slidesPerView: 'auto'
  });

  const zineSwiper = new Swiper('#zine-slide', {
    loop: true,
    speed: 1000,
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  //mailtoUI
  if(/chrom(e|ium)/.test(navigator.userAgent.toLowerCase())){
    var script = $('<script>').attr({
      'type': 'text/javascript',
      'src': 'https://cdn.jsdelivr.net/npm/mailtoui@1.0.3/dist/mailtoui-min.js',
      'data-options': '{"title": "メールの送信方法を選択する", "buttonText1": "ブラウザでGmailを開く", "buttonText2": "ブラウザでOutlookを開く", "buttonText3": "ブラウザでYahooを開く", "buttonText4": "デフォルトのメールソフトを開く", "buttonTextCopy": "コピー"}'
    });
    $('body')[0].appendChild(script[0]);
  }
}
